
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLatched as ObiLatchedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-latched.js';
 
 
 

 
 export const ObiLatched = createComponent({
   react: React,
   tagName: 'obi-latched',
   elementClass: ObiLatchedElement,
   events: {
     
   }
  });
 
 